import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PouchdbService } from "../../shared/pouchDb.service"
import { Constants } from '../../shared/models/constants';
import { Http, Headers, Request, Response, RequestOptions } from '@angular/http';
import { Component_interactionService } from '../../component_interaction.service';
import { ShelfPouchDb } from '../shelf.pouchdb.service';


@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.css']
})
export class ActivityComponent implements OnInit {
  isShowActivityPopup = false;
  activityHeadetTitle;
  localDB;
  currentUserId;
  activityList: any = [];
  currentactivityDetails: any = [];
  userInfo: any = {};
  updatingAnswerSheetsSync;
  answerSheetList = [];
  constructor(public pouchService: PouchdbService, private cdr: ChangeDetectorRef, private http: Http, private Component_interactionService: Component_interactionService) { }



  ngOnInit() {
    document['examNative'] = this;
    let strnUserdata = JSON.parse(localStorage.nasResponse)
    if (strnUserdata.signIn && strnUserdata.signIn.user) {
      this.userInfo = strnUserdata.signIn.user;
      // this.userInfo.role = 'TEACHER';
      this.getActivityFromDB();

    }


    this.updatingAnswerSheetsSync = this.Component_interactionService.updatingAnswerSheets$.subscribe(ansSheetsArr => {
      console.log(ansSheetsArr);
      if (ansSheetsArr.length > 0) {
        let com: any = document.getElementsByClassName('examEditorContainer');
        if (com && com[0]) {
          com = com[0].contentWindow;
          if (com.broadcastAnalyticsChange)
            com.broadcastAnalyticsChange(ansSheetsArr);
        }
      }
    })

  }


  isStageReady(state) {
    if (state) {
      let com: any = document.getElementsByClassName('examEditorContainer');
      if (com) {
        com = com[0].contentWindow;
        // this.currentactivityDetails = {};
        com.sendActivityData(this.currentactivityDetails);
      }
    }
  }

  updateDBAnswerDocument(answersheet, isEndTest) {
    var self = this;
    answersheet = JSON.parse(answersheet);
    this.currentactivityDetails.answersheet = answersheet;
    this.pouchService.localDB.find({
      selector: { type: 'answersheet', _id: answersheet._id },
    }).then(function (result) {
      if (result.docs.length > 0) {
        answersheet._rev = result.docs[0]._rev;
        return self.pouchService.localDB.put(answersheet).then(function (response) {
          if (isEndTest) {
            self.isShowActivityPopup = false;
            self.cdr.detectChanges();
          }

          self.pouchService.replicateExportDoc(response.id);


        }).catch(function (err) {
          console.log(err);
        });
      }
    })
  }


  changeInboxOutBox(event) {

    var value = event;
    if (event.index == 0) {
      this.getActivityFromDB();
    }

    else {
      this.getActivitiesFromDB();
    }
  }


  getActivityFromDB() {
    this.currentUserId = Constants.USER;
    let data = this.pouchService;
    this.localDB = data.localDB;
    let self = this;
    this.pouchService.localDB.find({
      selector: { type: 'answersheet' },
    }).then(function (result) {

      self.answerSheetList = result.docs;
    }).catch(function (err) {
    });
  }

  getActivityAnswersheets(act) {
    let data = this.pouchService;
    this.localDB = data.localDB;
    let seft = this;
    this.pouchService.localDB.find({
      selector: { type: 'answersheet', activityId: act._id },
    }).then(function (result) {


      if (result.docs.length > 0) {
        seft.currentactivityDetails.answersheet = result.docs;
        seft.currentactivityDetails.activity.loginRole = "teacher";
        seft.isShowActivityPopup = true;
      }

    }).catch(function (err) {
    });
  }

  getActivitiesFromDB() {
    this.currentUserId = Constants.USER;
    let data = this.pouchService;
    this.localDB = data.localDB;
    let seft = this;

    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.userToken);
    const options = new RequestOptions({ headers: headers });
    this.http.post(
      "http://lcsgql-dev.semanooor.com/graphql", {
        "query": "query GET_ACTIVITIES($pageIndex: String,$pageSize: String,$columnName: ActivityColumns,$order: orderByDetailsInCaps) {getActivities(where: {pageIndex: $pageIndex,pageSize:$pageSize,columnName:$columnName,order:$order}) {\
          isApprovedExam\
          _id\
          name\
          isApprovedExam\
          security\
          thumbnail\
          activityInfo{\
            fromdatetime\
            todatetime\
            description\
            schoolName\
            address\
            timeduration\
          }\
          questions\
          users    }}",
        variables: {
          "pageIndex": "1",
          "pageSize": "100",
          "columnName": "createdAt",
          "order": "DESC"
        }
      }, options
    ).subscribe(
      res => {
        seft.activityList = res.json().data.getActivities;
      }
    );
  }
  // setAnswersheetFromDB(res){
  //   this.currentactivityDetails.curAnswersheet = res
  // }


  sendActivityData(opt) {
    // if (this.userInfo && this.userInfo.role != 'TEACHER')


    //   this.activityHeadetTitle = opt.activityName;
    // else if (this.userInfo && this.userInfo.role == 'TEACHER')
    //   this.activityHeadetTitle = opt.name;
    // // this.activityHeadetTitle = opt.activityName;
    // let self = this;
    // if (this.userInfo && this.userInfo.role == 'TEACHER') {

    // }


    this.currentactivityDetails.activity = opt;
    this.getActivityAnswersheets(opt);

  }

  getActivityFromAnswerSheet(opt) {

    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.userToken);
    const options = new RequestOptions({ headers: headers });

    var activityId = opt.activityId;
    this.currentactivityDetails.answersheet = opt;

    this.http.post(
      "http://lcsgql-dev.semanooor.com/graphql", {
        "query": "query GET_ACTIVITY_BY_ID($activityId: String!) {getActivityById(where: {activityId: $activityId}) {_id name \
        isApprovedExam\
        security\
        thumbnail\
        active\
        activityInfo{\
          fromdatetime\
          todatetime\
          description\
          schoolName\
          address\
          timeduration\
          }\
        questions\
        users    }}",
        variables: {
          "activityId": activityId
        }
      }, options
    ).subscribe(
      res => {

        this.currentactivityDetails.activity = res.json().data.getActivityById;
        this.isShowActivityPopup = true;
      }

    );

  }

  deleteAnswerSheet(obj) {

  }

  hideActivityPopup() {
    if (this.currentactivityDetails.activity.loginRole != "teacher") {
      this.currentactivityDetails.answersheet.status = 'Left Exam';
      this.currentactivityDetails.answersheet.currentQuestion = -1;
      let ansSheet = JSON.stringify(this.currentactivityDetails.answersheet);
      this.updateDBAnswerDocument(ansSheet, false);
    }
    this.isShowActivityPopup = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shelf/activity/activity.component.ts